import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { addDays, format, isAfter, isEqual, isWeekend, subDays } from 'date-fns'
import { useState } from 'react'
import { Link as ReactRouterLink, useParams } from 'react-router-dom'

import { Card, Icon, Link, Rule, Tabs } from '@/components/core-v2'
import { LoadingSpinner } from '@/components/core-v2/atoms/loading-spinner'
import { PATH, TODAY } from '@/const'

import { TradeEventsStatisticsLoading } from '../../components/trade-events-statistics/loading'
import { TradeTemplate } from '../../templates/trade-template'
import { DAY_GRID_START, ROW_HEIGHT } from '.'
import classes from './index.module.scss'

export const Loading = () => {
  const { '*': splat, date: stringDate, source, tradeId } = useParams()
  const [selectedDate] = useState(new Date(stringDate))
  const [tab] = splat.split('/')

  const weekDates = [
    subDays(selectedDate, 3),
    subDays(selectedDate, 2),
    subDays(selectedDate, 1),
    selectedDate,
    addDays(selectedDate, 1),
    addDays(selectedDate, 2),
    addDays(selectedDate, 3)
  ]

  return (
    <TradeTemplate tabValue="events">
      <div className={classes.datePickerWrapper}>
        <span className={classes.selectedDateHeading}>
          {format(selectedDate, 'EEEE d MMMM yyyy')}
        </span>
        <Skeleton variant="text" width="145px" />
      </div>
      <Card.Wrapper className={classes.wrapper}>
        <TradeEventsStatisticsLoading />

        <Rule className={classes.rule} />
        <div className={clsx(classes.eventsWrapper)}>
          <div
            className={classes.eventGridWrapper}
            style={{ gridTemplateRows: `100px repeat(1, ${ROW_HEIGHT}) 24px` }}
          >
            <Link aria-disabled className={classes.prevBtn} to="/" variant="link">
              <Icon className="mr-half" name="chevronLeft" />
              prev
            </Link>
            {weekDates.map((date, index) => {
              const formattedDate = format(date, 'dd-MM-yyyy')
              return (
                <ReactRouterLink
                  key={formattedDate}
                  aria-disabled={isWeekend(date)}
                  className={clsx(classes.dayWrapper, {
                    [classes.weekend]: isWeekend(date),
                    [classes.today]: isEqual(date, selectedDate)
                  })}
                  style={{ gridColumnStart: index + DAY_GRID_START }}
                  to={PATH.reportsSingleTradeEventsHoldings(source, tradeId, date)}
                >
                  <h4
                    className={clsx(classes.dateHeading, {
                      [classes.faded]: isWeekend(date) || isAfter(date, TODAY),
                      [classes.today]: isEqual(date, selectedDate)
                    })}
                  >
                    <span className={classes.number}>{format(date, 'dd')}</span>
                    <span className={classes.day}>{format(date, 'EEEE')}</span>
                  </h4>
                </ReactRouterLink>
              )
            })}
            <LoadingSpinner className={classes.spinner} />
            <Link
              aria-disabled
              className={classes.nextBtn}
              to={PATH.reportsSingleTradeEventsHoldings(source, tradeId, selectedDate)}
              variant="link"
            >
              next <Icon className="ml-half" name="chevronRight" />
            </Link>
          </div>
        </div>

        <div className={classes.tabsWrapper}>
          <Tabs.List aria-label="Events tabs" className="mt-12" ruleClassName="mb-10" spacing="md">
            <Tabs.Tab
              isSelected={tab === 'holdings'}
              to={PATH.reportsSingleTradeEventsHoldings(source, tradeId, selectedDate)}
              value="holdings"
            >
              Holdings
            </Tabs.Tab>
            <Tabs.Tab
              isSelected={tab === 'parameters'}
              to={PATH.reportsSingleTradeEventsParameters(source, tradeId, selectedDate)}
              value="parameters"
            >
              Parameters
            </Tabs.Tab>

            <Tabs.Tab
              isSelected={tab === 'events'}
              to={PATH.reportsSingleTradeEventsEvent(source, tradeId, selectedDate, '')}
              value="events"
            >
              Events
            </Tabs.Tab>
          </Tabs.List>
        </div>
      </Card.Wrapper>
    </TradeTemplate>
  )
}
